import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {FilterRoutingModule} from './filter-routing.module';
import {FilterComponent} from './filter/filter.component';
import {FilterBodyComponent} from './filter-body/filter-body.component';
import {FilterProductGridComponent} from './filter-product-grid/filter-product-grid.component';
import {FilterContainerComponent} from './filter-container/filter-container.component';
import {FilterProductPreviewComponent} from './filter-product-preview/filter-product-preview.component';
import {PipeModule} from "../pipe/pipe.module";
import {FilterControlComponent} from './filter-control/filter-control.component';
import {MatCheckboxModule} from "@angular/material/checkbox";
import {FormsModule} from "@angular/forms";
import {FilterRangeControlComponent} from './filter-range-control/filter-range-control.component';
import {MatSliderModule} from "@angular/material/slider";
import {DirectiveModule} from "../directive/directive.module";
import {FilterProductPreviewSkeletonComponent} from './filter-product-preview-skeleton/filter-product-preview-skeleton.component';
import {FilterToggleControlComponent} from './filter-toggle-control/filter-toggle-control.component';
import {FilterSortDropdownComponent} from './filter-sort-dropdown/filter-sort-dropdown.component';
import { FilterPaginatorComponent } from './filter-paginator/filter-paginator.component';
import { FilterActiveControlsComponent } from './filter-active-controls/filter-active-controls.component';


@NgModule({
    declarations: [
        FilterComponent,
        FilterBodyComponent,
        FilterProductGridComponent,
        FilterContainerComponent,
        FilterProductPreviewComponent,
        FilterControlComponent,
        FilterRangeControlComponent,
        FilterProductPreviewSkeletonComponent,
        FilterToggleControlComponent,
        FilterSortDropdownComponent,
        FilterPaginatorComponent,
        FilterActiveControlsComponent
    ],
    exports: [
        FilterBodyComponent
    ],
    imports: [
        CommonModule,
        FilterRoutingModule,
        PipeModule,
        MatCheckboxModule,
        FormsModule,
        MatSliderModule,
        DirectiveModule,
    ]
})
export class FilterModule { }
